import {TestIdProps} from './TestIdProps';

export interface RequiredTestIdProps extends Required<TestIdProps> {}
